import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormOverdueSignConfig } from '../models/form/form-overdue-sign-config.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class FormOverdueSignConfigService extends RequestService<FormOverdueSignConfig> {
  static PATH = '/om/form/overdueSignConfig';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      FormOverdueSignConfigService.PATH,
      globalService.debugUrl
    );
  }
}
